/** A presentation-only account, never an operational administrator. */
export function isRoadMoverInvestor(user: { username?: string; brand?: string | null } | null | undefined): boolean {
  return user?.username?.toLowerCase() === "cowboy" && user.brand === "roadmover";
}
